import { SparkRewardsContainer } from '@/features/spark-rewards/SparkRewardsContainer'

export function SparkRewards() {
  return <SparkRewardsContainer />
}
